import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { ChildrenProvider } from "@/context/ChildrenContext";
import AuthPage from "@/pages/AuthPage";
import AuthCallback from "@/pages/AuthCallback";
import AppShell from "@/components/AppShell";
import DashboardPage from "@/pages/DashboardPage";
import AdvicePage from "@/pages/AdvicePage";
import ActivitiesPage from "@/pages/ActivitiesPage";
import QuizPage from "@/pages/QuizPage";
import JournalPage from "@/pages/JournalPage";
import ChallengesPage from "@/pages/ChallengesPage";
import AlbumPage from "@/pages/AlbumPage";
import CoachPage from "@/pages/CoachPage";
import RitualPage from "@/pages/RitualPage";
import StoriesPage from "@/pages/StoriesPage";
import SubscribePage from "@/pages/SubscribePage";
import ReferralsPage from "@/pages/ReferralsPage";
import GiftsPage from "@/pages/GiftsPage";
import { PaymentSuccessPage, PaymentCancelPage } from "@/pages/PaymentPages";

function Protected({ children }) {
  const { user, loading } = useAuth();
  if (loading) return <div className="min-h-screen grid place-items-center text-[#77849C]">Chargement...</div>;
  if (!user) return <Navigate to="/auth" replace />;
  return children;
}

function AppRoutes() {
  const { user } = useAuth();
  const location = useLocation();

  // Synchronous check for Google OAuth callback (must run BEFORE ProtectedRoute)
  if (location.hash && location.hash.includes("session_id=")) {
    return <AuthCallback />;
  }

  return (
    <Routes>
      <Route path="/auth" element={user ? <Navigate to="/" replace /> : <AuthPage />} />
      <Route path="/auth/callback" element={<AuthCallback />} />
      <Route path="/payment/success" element={<Protected><PaymentSuccessPage /></Protected>} />
      <Route path="/payment/cancel" element={<Protected><PaymentCancelPage /></Protected>} />
      <Route
        path="/*"
        element={
          <Protected>
            <ChildrenProvider>
              <AppShell>
                <Routes>
                  <Route path="/" element={<DashboardPage />} />
                  <Route path="/rituel" element={<RitualPage />} />
                  <Route path="/conseils" element={<AdvicePage />} />
                  <Route path="/activites" element={<ActivitiesPage />} />
                  <Route path="/quiz" element={<QuizPage />} />
                  <Route path="/journal" element={<JournalPage />} />
                  <Route path="/defis" element={<ChallengesPage />} />
                  <Route path="/album" element={<AlbumPage />} />
                  <Route path="/contes" element={<StoriesPage />} />
                  <Route path="/coach" element={<CoachPage />} />
                  <Route path="/abonnement" element={<SubscribePage />} />
                  <Route path="/parrainage" element={<ReferralsPage />} />
                  <Route path="/cadeaux" element={<GiftsPage />} />
                  <Route path="*" element={<Navigate to="/" replace />} />
                </Routes>
              </AppShell>
            </ChildrenProvider>
          </Protected>
        }
      />
    </Routes>
  );
}

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <AppRoutes />
        </BrowserRouter>
        <Toaster position="top-right" richColors />
      </AuthProvider>
    </div>
  );
}

export default App;
